import { stat } from "fs";
import { combineReducers } from "redux";

// const state_data = {
//     channel: null,
//     channels:[],
//     data: []
// }

const chatReducer = (state = {}, action) => {
  switch (action.type) {
    case "CREATE_CHAT":
      let channel = action.payload;
      return { ...state, channel };
    case "GET_CHANNEL":
      let data = action.payload;
      return { ...state, data };
    case "GET_CHART_CHANNEL":
      let channels = action.payload;
      return { ...state, channels };
    case "USER_CHANNELS":
      let userChannels = action.payload;
      return { ...state, userChannels}
    case "EXPAND_CHAT":
      let expandChart = action.payload;
      return {...state,expandChart}
    case "ACTIVE_TILES":
      let activeTiles = action.payload;
      return{...state,activeTiles}
    default:
      return state;
  }
};

export default chatReducer;
